import { reactive, computed, watch } from "vue";
import trans from "helpers/_translation";

const titleMap = {
	"details": "Gegegevens",
	"attachments": "Bijlagen",
	"comments": "Opmerkingen",
	"inbox": "Inbox"
};
export const workflowcardPopoverData = reactive({
	type: "details",
	item: null,
	open: false,
	workflowboard_id: null,
	workflowphase_id: null
});

export const workflowcardPopoverTitle = computed(() => {
	return trans(titleMap?.[workflowcardPopoverData.type] ?? "Gegevens");
});
export const workflowcardPopoverId = computed(() => {
	return workflowcardPopoverData.item?.id ?? null;
});
export const workflowcardPopoverType = computed(() => {
	return workflowcardPopoverData.type ?? "details";
});

export const storeWorkflowcardPopoverType = (type) => {
	workflowcardPopoverData.type = type;
};
export const storeWorkflowcardPopoverData = (type, item) => {
	workflowcardPopoverData.type = type;
	workflowcardPopoverData.item = item;
};
export const openWorkflowcardPopover = (workflowboard_id, workflowphase_id) => {
	workflowcardPopoverData.open = true;
	workflowcardPopoverData.workflowboard_id = workflowboard_id;
	workflowcardPopoverData.workflowphase_id = workflowphase_id;
};
export const closeWorkflowcardPopover = () => {
	workflowcardPopoverData.open = false;
};

watch(
	() => workflowcardPopoverData.open,
	(open) => {
		if (open) {
			document.body.classList.add("popover-open");
		} else {
			document.body.classList.remove("popover-open");
		}
	}
)
